<template>
    <div id="ctcp">
        <div class="ct-navbar-content">
            <div class="ct-logo">
                <img src="/images/ct-logo.png" />
            </div>
        </div>
        <main>
            <router-view></router-view>
        </main>
        <footer>
            <a :href="$t('link.dataprivacy')">{{ $t('linklabel.dataprivacy') }}</a>
            <a :href="$t('link.impressum')">{{ $t('linklabel.impressum') }}</a>
        </footer>

        <!-- Matomo Image Tracker-->
        <img v-if="isProduction" :src="matomoUrl" style="border:0" alt="" />
        <!-- End Matomo -->
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {
        registrationFinished: function() {
            return this.$store.getters['registrations/registerInformation'].registerFinished;
        },
        header: function() {
            return this.$store.getters['registrations/registerInformation'];
        },
        isProduction() {
            return window.location.hostname !== 'localhost';
        },
        /**
         * @see https://matomo.org/faq/how-to/faq_176/
         */
        matomoUrl() {
            let referrer = document.referrer;
            const urlParams = new URLSearchParams(window.location.search);
            const sitename = urlParams.get('sitename');
            if (sitename !== null) {
                referrer = `https://${sitename}.church.tools`;
            }

            const location = document.location;
            return `https://analytics.ct-srv.de/matomo.php?idsite=3&rec=1&action_name=ChurchTools+Customer+Portal&url=${location}&urlref=${referrer}`;
        }
    },
    methods: {}
};
</script>
